/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Checkbox, Select,
  Input,
} from 'antd';
import CurrenciesActions from '@Actions/configurations/currenciesAction';
import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const CurrencyConversion = ({
  selectedCurrencyName, selectedCurrencyID, setSelectedCurrencyID, setSelectedCurrencyName, setIsAutomaticConversionRate, setCurrencyConversionRate, isAutomaticConversionRate, CurrenciesResults, getCurrenciesLoading, currencyConversionRate, callback,
}) => {
  return (
    <Fragment>
      {!selectedCurrencyName?.is_default && (
        <Fragment>
          <div style={{ marginLeft: '5px', textAlign: 'right', width: '200px' }}>
            <Checkbox
              checked={isAutomaticConversionRate}
              onChange={(e) => {
                const selectedCurrency = selectedCurrencyName;
                const conversionRate = e?.target?.checked ? selectedCurrency?.automatic_conversion_rate
                  : selectedCurrency?.conversion_rate;
                setCurrencyConversionRate(conversionRate);
                setIsAutomaticConversionRate(e?.target?.checked);
                if (callback) {
                  callback(conversionRate);
                }
              }}
              style={{ fontSize: '12px' }}
              disabled={getCurrenciesLoading || selectedCurrencyName?.is_default}
            >
              Automatic Conversion rate
            </Checkbox>
          </div>
          <Input
            type="number"
            size="small"
            style={{ width: '110px' }}
            value={currencyConversionRate}
            disabled={isAutomaticConversionRate || getCurrenciesLoading || selectedCurrencyName?.is_default}
            onChange={(e) => {
              const conversionRate = e?.target?.value > 0 ? e?.target?.value : 0.1;
              setCurrencyConversionRate(conversionRate);
              if (callback) {
                callback(conversionRate);
              }
            }}
          />
        </Fragment>
      )}
      <div style={{ marginLeft: '5px', textAlign: 'right' }}>
        <PRZSelect
          onChange={(value) => {
            const selectedCurrency = CurrenciesResults?.find(
              (currency) => currency?.org_currency_id === value,
            );
            const conversionRate = isAutomaticConversionRate ? selectedCurrency?.automatic_conversion_rate : selectedCurrency?.conversion_rate;
            setSelectedCurrencyID(value);
            setSelectedCurrencyName(selectedCurrency);
            setCurrencyConversionRate(conversionRate);
            if (callback) {
              callback(conversionRate);
            }
          }}
          value={selectedCurrencyID}
          style={{
            width: '100px',
          }}
          // className="currency__selector"
          loading={getCurrenciesLoading}
          options={CurrenciesResults?.map((currency) => ({
            value: currency?.org_currency_id, // Use a unique identifier as the value
            label: `${currency.currency_code} (${currency.currency_symbol})`,
          }))}
          disabled
          placeholder=""
        />
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, CurrenciesReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  CurrenciesResults: CurrenciesReducers.CurrenciesResults,
  getCurrenciesLoading: CurrenciesReducers.getCurrenciesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCurrencies: (orgId) => dispatch(CurrenciesActions.getCurrencies(orgId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CurrencyConversion));
